import { defineComponent as d, computed as l, openBlock as s, createElementBlock as i, createElementVNode as t, toDisplayString as h, createCommentVNode as f, normalizeStyle as n, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "aeb00bcb-e2e5-4ba6-90d7-df51b22f1f59" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#aeb00bcb-e2e5-4ba6-90d7-df51b22f1f59)" }, u = { key: 0 }, v = /* @__PURE__ */ p('<path fill="#0052b4" d="M0 0h144.7l36 254.6-36 257.4H0z"></path><path fill="#d80027" d="M367.3 0H512v512H367.3l-29.7-257.3z"></path><path fill="#ffda44" d="M144.7 0h222.6v512H144.7z"></path><path fill="#ff9811" d="M345.1 201.4H284a27.8 27.8 0 1 0-55.6 0h-61.2a28.2 28.2 0 0 0 28.3 27.4h-1a27.4 27.4 0 0 0 27.5 27.4c0 13.4 9.6 24.5 22.3 27l-21.6 48.7a88.8 88.8 0 0 0 33.5 6.5 88.8 88.8 0 0 0 33.5-6.5L268.1 283a27.4 27.4 0 0 0 22.3-26.9 27.4 27.4 0 0 0 27.4-27.4h-.9a28.2 28.2 0 0 0 28.3-27.4z"></path><path fill="#0052b4" d="M256.1 239.3 220 256v33.4l36.2 22.3 36.2-22.3V256z"></path><path fill="#d80027" d="M220 222.6h72.3V256H220z"></path>', 6), g = { fill: "none" }, b = ["r"], y = /* @__PURE__ */ d({
  __name: "md",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(c) {
    const e = c, o = l(() => 512 + 2 * e.strokeWidth), a = l(() => -e.strokeWidth), r = l(() => 256 + e.strokeWidth / 2);
    return (x, z) => (s(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${a.value} ${a.value} ${o.value} ${o.value}`
    }, [
      m,
      t("g", k, [
        e.flagName ? (s(), i("title", u, h(e.flagName), 1)) : f("", !0),
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: n({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, b)
      ])
    ], 8, _));
  }
});
export {
  y as default
};
//# sourceMappingURL=md-50793282.js.map
